import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Alert } from 'antd';
import styled from 'styled-components';
export const DownloadIcon = styled(DriveFolderUploadIcon)`
  background: rgba(255, 186, 0, 0.1);
  border-radius: 50%;
  color: #98a9bc;
  padding: 5px;
  font-size: 56px !important;
  margin-top: 30px;
`;
export const Spacer = styled.div`
  padding-bottom: 30px;
`;
export const UploadButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: 10px;
  margin-bottom: 10px;
`;
export const UploadedItem = styled.div`
  color: rgba(0, 0, 0, 0.85);
  font-weight: 12px;
`;
export const ClearButton = styled.span`
  cursor: pointer;
  color: #fff;
  transition: 0.2s;
  border: 1px solid #151515;
  margin-left: 10px;
  border-radius: 50px;
  padding: 2px 12px;
  font-size: 12px;
  background-color: #151515;

  svg {
    color: #fff;
  }

  &:hover {
    color: #151515;
    background: #fff;
    svg {
      color: #151515;
    }
  }
`;
export const UploadMaxSize = styled.span`
  color: lightgrey;
  font-size: 12px;
`;
export const UploadAlert = styled(Alert)`
  margin: 20px 0;
`;
export const UploadErrorAlert = styled(Alert)`
  margin: 5px 0;
`;